import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedSuggestedEdge, dismissRelationshipSuggestion } from 'store/graph/actions';
import { selectSuggestedEdgeByKey } from 'store/graph/selectors';
import SignalTabs from './signal-tabs';
import ConfidenceSection from './confidence-section';
import PersonCard from './person-card';
import './style.css';

const SuggestedEdgeDetailPanel = ({ edgeKey, onConfirm }) => {
  const dispatch = useDispatch();
  const edge = useSelector(selectSuggestedEdgeByKey(edgeKey));

  useEffect(() => {
    // Render log removed for SuggestedEdgeDetailPanel
  }, [edgeKey, edge]);

  if (!edge) {
    return null;
  }

  const handleClose = () => {
    // Close clicked (log removed)
    dispatch(setSelectedSuggestedEdge(null));
  };

  const handleDismiss = () => {
    // Dismiss clicked (log removed)
    dispatch(dismissRelationshipSuggestion(edge.id1, edge.id2));
    handleClose();
  };

  const { signals, confidence, metadata, id1, id2 } = edge;
  const stopEvent = (event) => {
    event.stopPropagation();
  };

  return (
    <div
      className="suggested-edge-detail-panel"
      role="dialog"
      aria-modal="true"
      aria-labelledby="suggested-relationship-header"
      onMouseDown={stopEvent}
      onClick={stopEvent}
    >
      <div className="panel-header" id="suggested-relationship-header">
        <h3>Suggested Relationship</h3>
        <button type="button" onClick={handleClose} className="close-btn">&times;</button>
      </div>
      <div className="panel-content">
        <div className="signal-pills">
          {signals.map(signal => (
            <span key={signal} className={`pill ${signal}`}>{signal}</span>
          ))}
        </div>
        
        <div className="person-cards-container">
            <PersonCard personId={id1} />
            <span className="connector-arrow">↔</span>
            <PersonCard personId={id2} />
        </div>

        <ConfidenceSection confidence={confidence} />
        
        <SignalTabs signals={signals} metadata={metadata} />

      </div>
      <div className="panel-footer">
        <button type="button" className="dismiss-btn" onClick={handleDismiss}>Dismiss</button>
        <button
          type="button"
          className="confirm-btn"
          onClick={() => {
            // Confirm clicked (log removed)
            onConfirm();
          }}
        >
          Confirm
        </button>
      </div>
    </div>
  );
};

export default SuggestedEdgeDetailPanel;
